
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kqFte", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c8c081b3d4ba0626$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $c8c081b3d4ba0626$export$2e2bcd8739ae039 = {
    'confluence.error.panel.refresh.app': 'App aktualisieren',
    'confluence.error.panel.reload.page': 'Seite neu laden',
    'confluence.icon.label': 'Symbol',
    'confluence.modal.dialog.close.modal.button': 'Abbrechen',
    'confluence.select.required.field.message': 'Dieses Feld ist ein Pflichtfeld.',
    'confluence.text.area.required.field.message': 'Dieses Feld ist ein Pflichtfeld.',
    'confluence.textfield.validator.email': "Bitte geben Sie eine g\xfcltige E-Mail-Adresse ein.",
    'confluence.textfield.validator.number': "Bitte eine g\xfcltige Zahl eingeben",
    'confluence.textfield.validator.required.field.message': 'Dieses Feld ist ein Pflichtfeld.',
    'confluence.textfield.validator.telephone': "Bitte geben Sie eine g\xfcltige Telefonnummer ein.",
    'confluence.threeLOPrompt.modal.access.required.title': 'Zugriff erforderlich',
    'confluence.threeLOPrompt.modal.error.title': 'Fehler',
    'confluence.threeLOPrompt.modal.no.authURL.error-message': 'Zustimmungs-URL konnte nicht gefunden werden. Aktualisieren Sie die Seite und versuchen Sie es dann erneut.',
    'confluence.threeLOPrompt.no.authURL.error-message': 'Zustimmungs-URL konnte nicht gefunden werden. Aktualisieren Sie die Seite und versuchen Sie es dann erneut.',
    'confluence.threeLOPrompt.use-auth.allow.access.button.text': 'Zugriff gestatten',
    'confluence.threeLOPrompt.use-auth.configure.access.button.text': 'Zugriff konfigurieren',
    'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message': 'Authentifizierung fehlgeschlagen.',
    'confluence.threeLOPrompt.use-auth.default.prompt.message': "Damit {appString} angezeigt wird, m\xfcssen Sie der App erlauben, in Ihrem Namen auf Atlassian-Produkte zuzugreifen.",
    'confluence.threeLOPrompt.use-auth.external.auth.prompt.message': "{appString} ben\xf6tigt zus\xe4tzlichen Zugriff auf Ihr Konto.",
    'confluence.threeLOPrompt.use-auth.external.auth.warning.message': "Externe Authentifizierung\xa0\u2013 Warnung",
    'confluence.threeLOPrompt.use-auth.this.app.lower.message': 'diese App',
    'confluence.threeLOPrompt.use-auth.this.app.upper.message': 'Diese App',
    'confluence.user.group.unknown.user.message': 'Unbekannter Benutzer',
    'confluence.user.picker.empty.field.error.message': 'Dieses Feld ist ein Pflichtfeld.',
    'confluence.user.unknown.user.message': 'Unbekannter Benutzer',
    'forge-ui.form.submit-button.text': 'Senden'
};

});


//# sourceMappingURL=de.34aac01d.js.map
